<template>
    <div class="" :class="{hidden: !loading}">
        <loading></loading>
    </div>
    <div :class="{hidden: loading}">
        <div v-if="consumables.length">
            <form action="" class="form form--floating-label" @submit.prevent="formSubmit" ref='form' >
                <div class="style-emph mb-4">
                    Consumables
                </div>

                <div class="rounded-xl shadow-100 bg-white mb-11">
                    <div class="grid-cols-10 items-center grid py-3 px-7 ">
                        <div></div>
                        <div class="style-title-1 col-span-7">
                            Description
                        </div>
                        <div class="style-title-1 col-span-2 text-right">
                            Select
                        </div>
                    </div>

                    <div v-for="consumable in consumables" :key="consumable.id" @click="consumable.selected = !consumable.selected"  class="grid-cols-10 items-center grid py-3 px-7 hover:bg-blue-white border-t-2 border-gray cursor-pointer" >
                        <div>
                            <span v-if="consumable.colour" class="leading-none inline-block h-3 w-3 rounded-xl" :style="{backgroundColor: '#' + consumable.colour}">&nbsp;</span>
                        </div>
                        <div class="col-span-7">
                            <div class="style-body">
                                {{consumable.description}}
                            </div>
                            <div class="style-body text-gray-500">
                                {{consumable.part_number}}
                            </div>
                            <div class="style-body mt-1">
                                {{ moneyFormat(consumable.price) }}
                            </div>
                        </div>
                        <div class="col-span-2 input-container--check">
                    <span class="flex justify-start items-start cursor-pointer">
                        <div class="bg-white border rounded border-blue-gray w-6 h-6 flex flex-shrink-0 justify-center items-center ml-auto">
                            <input type="checkbox" class="opacity-0 absolute" v-model="consumable.selected">
                            <svg class="fill-current hidden w-4 h-4 text-red pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
                        </div>
                    </span>
                        </div>
                    </div>
                    <div class="grid-cols-10 items-center grid py-3 px-7 border-t-2 border-gray">
                        <div></div>
                        <div class="col-span-5">
                            <span class="style-title-1 white">
                                Qty: <span class="font-medium text-blue-black">{{ totalQty }}</span>
                            </span>
                        </div>
                        <div class="col-span-4 style-body font-medium text-right">
                            {{ moneyFormat(totalPrice) }}
                        </div>
                    </div>

                    <div v-if="currentItem.consumable_fee_amount">
                        <div class="grid-cols-10 items-center grid py-3 px-7 border-t-2 border-gray">
                            <div></div>
                            <div class="col-span-5">
                            <span class="style-title-1 white">
                                {{ currentItem.consumable_fee_des }}
                            </span>
                            </div>
                            <div class="col-span-4 style-body font-medium text-right">
                                {{ moneyFormat(currentItem.consumable_fee_amount) }}
                            </div>
                        </div>

                        <div class="grid-cols-10 items-center grid py-3 px-7 border-t-2 border-gray">
                            <div></div>
                            <div class="col-span-5">
                            <span class="style-title-1 white">
                                Total
                            </span>
                            </div>
                            <div class="col-span-4 style-body font-medium text-right">
                                {{ moneyFormat(totalPrice + currentItem.consumable_fee_amount) }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="style-emph mb-4">
                    Contact Information
                </div>

                <div class="input-container input-container--floating relative h-12 mb-5 " :class="{empty: !formData.contact, error: submittedOnce && errors.contact}">
                    <input
                            id="contact-name"
                            type="text"
                            v-model="formData.contact"
                            class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue "
                    />
                    <label for="contact-name" class="absolute left-2 transition-all bg-white px-1 text-blue-gray">
                        Contact Name
                    </label>
                </div>

                <div class="input-container input-container--floating relative h-12 mb-5 " :class="{empty: !formData.email , error: submittedOnce && errors.email}">
                    <input
                            id="email"
                            type="email"
                            v-model="formData.email"
                            class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
                    />
                    <label for="email" class="absolute left-2 transition-all bg-white px-1 text-blue-gray">
                        Email Address
                    </label>
                </div>

                <div class="input-container input-container--floating relative h-12 mb-5 " :class="{empty: !formData.phone , error: submittedOnce && errors.phone}">
                    <input
                            id="phone"
                            type="text"
                            v-model="formData.phone"
                            class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
                    />
                    <label for="phone" class="absolute left-2 transition-all bg-white px-1 text-blue-gray">
                        Phone
                    </label>
                </div>

                <div class="input-container input-container--floating relative h-12 mb-5 " :class="{empty: !formData.order_number , error: submittedOnce && errors.order_number}">
                    <input
                            id="order_number"
                            type="text"
                            v-model="formData.order_number"
                            class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
                    />
                    <label for="phone" class="absolute left-2 transition-all px-1 text-blue-gray">
                        Order Number
                    </label>
                </div>

                <div class="input-container input-container--floating relative mb-5 " :class="{empty: !formData.comment, error: submittedOnce && errors.comment}">
                    <textarea
                            id="comment"
                            v-model="formData.comment"
                            class="h-full w-full px-2 pt-3 transition-all border-blue-gray rounded text-blue">
                    </textarea>

                    <label for="comment" class="absolute left-2 transition-all bg-white px-1 text-blue-gray">
                        Type additional notes here...
                    </label>
                </div>

                <div class="input-container input-container--check mb-5 ">
                    <label class="flex justify-start items-center cursor-pointer">
                        <div class="bg-white border rounded border-blue-gray w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2">
                            <input type="checkbox" class="opacity-0 absolute" v-model="formData.is_urgent">
                            <svg class="fill-current hidden w-4 h-4 text-red pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
                        </div>
                        <div class="select-none text-blue-dark style-body">Urgent (Freight on Urgent Delivery is chargable)</div>
                    </label>
                </div>

                <div v-if="submittedOnce && errors.message" class="bg-red text-white mt-10 mb-5 px-3 py-2 rounded ">
                    {{ errors.message }}
                </div>

                <div class="mt-10 flex flex-col md:flex-row items-center ">
                    <button type="submit" class="btn w-full md:w-auto">Place Order</button>
                    <a
                            @click="goBack"
                            class="mt-3 md:mt-0 md:ml-8 text-red hover:text-red-hover font-light underline cursor-pointer">Cancel Form</a>
                </div>
            </form>
        </div>

        <div v-else class="style-body">
            No consumables available for online order, please <router-link :to="{ name: 'contact' }" class="text-red font-light underline">contact us</router-link>
            <div class="mt-4">
                <a
                        @click="goBack"
                        class="mt-3 md:mt-0 md:ml-8 text-red hover:text-red-hover font-light underline cursor-pointer">Go Back</a>
            </div>
        </div>
    </div>
</template>

<script charset="utf-8">

    import { values, join, get } from 'lodash';
    import Loading from '../includes/Loading.vue';
    import Vuex from 'vuex';

    export default {
        name: 'OrderForm',
        props: ['equipmentID'],
        data() {
            return {
                formData: {
                    contact: '',
                    phone: '',
                    email: '',
                    order_number: '',
                    is_urgent: false,
                    comment: ''
                },
                loading: true,
                submittedOnce: false,

                errors: {
                    contact: 'This field is required',
                    email: '',
                    phone: 'This field is required',
                    order_number: '',
                    message: ''
                }
            }
        },

        components: {
            Loading
        },

        emits: ["submit-success"],

        computed: {
            ...Vuex.mapGetters('profile', {
                profile: 'profile'
            }),
            ...Vuex.mapGetters('equipments', {
                consumables: 'consumables',
                currentItem: 'currentItem'
            }),

            totalQty: function () {
                if(this.consumables){
                    return this.consumables.filter(consumable => {
                        return consumable.selected;
                    }).length;
                }
                return 0;
            },
            totalPrice: function () {
                let total = 0;
                if(this.consumables){
                    this.consumables.forEach(consumable => {
                        if(consumable.selected){
                            total += consumable.price;
                        }
                    });
                }
                return total;
            }
        },
        watch: {
            formData: {
                handler(newVal){
                    this.errors.message = '';
                    this.errors.contact = newVal.contact ? '' : 'This field is required';
                    this.errors.phone   = newVal.phone.length >= 7 ? '' : 'Phone need to have at least 7 numbers';
                    this.errors.order_number  = !newVal.order_number && this.currentItem.order_number_required  ? 'This field is required' : '';

                    if(newVal.comment.length > 500){
                        newVal.comment = newVal.comment.substring(0,500);
                    }
                },
                deep: true
            },
            consumables: {
                handler(newVal){

                },
                deep: true
            }
        },

        created() {
            this.loading = true;
            if(this.profile.isAuth() && !this.profile.isSharpAdmin()){
                this.formData.contact  = this.profile.first_name +  ' ' + (this.profile.last_name ? this.profile.last_name : '');
                this.formData.phone  = this.profile.phone ? this.profile.phone : '';
                this.formData.email  = this.profile.email;
            }
            this.getConsumables(this.equipmentID)
                .then(() => {
                    this.loading = false;
                })
        },

        methods: {
            ...Vuex.mapActions('equipments', {
                createOrder: 'createOrder',
                getConsumables: 'getConsumables',
            }),

            moneyFormat(value) {
                return (value).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                });
            },

            formSubmit() {
                this.submittedOnce = true;
                this.errors.message = '';

                let selected = false;
                this.consumables.forEach(consumable => {
                    if(consumable.selected){
                        selected = true;
                    }
                });

                if(!selected){
                    this.errors.message = 'Please select at least 1 consumable';
                    return;
                }


                // do not submit if form has errors
                if (join(values(this.errors), '')) {
                    return;
                }

                let data = {
                    war_id: this.equipmentID,
                    contact: this.formData.contact,
                    email: this.formData.email,
                    phone: this.formData.phone,
                    is_urgent: this.formData.is_urgent,
                    comment: this.formData.comment,
                    cust_order_num : this.formData.order_number,
                    items: []
                };

                this.consumables.forEach(consumable => {
                    if(consumable.selected){
                        data.items.push({
                            stock_id: consumable.id,
                            quantity: 1
                        })
                    }
                });

                this.loading = true;
                this.createOrder(data)
                    .then(res => {
                        this.$emit('submit-success', res.job_number);
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                        this.errors = {
                            message: get(err, 'response.data.errors.0.message')
                        };
                    })

            },

            goBack(){
                if(!this.profile.isAuth()){
                    this.$router.push({
                        name: 'autologin', query: { war_id: this.currentItem ? this.currentItem.id : '', serial: this.currentItem ? this.currentItem.serial : '' }
                    });
                } else if(this.profile.isUser() || this.profile.isManager()){
                    this.$router.push({
                        name: 'dashboard'
                    });
                } else{
                    this.$router.go(-1);
                }

            }
        }
    }
</script>
